import { html } from 'lit';
import { ArrowLeft } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-arrow-left')
export class PdsIconArrowLeft extends PdsIcon {
  @state()
  icon = ArrowLeft;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
